function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var ReligionSvg = function ReligionSvg(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#231F20",
    d: "M10.8 13.9l-.2-.6-.6-.2L5.8 12l4.3-1.2.6-.1.2-.6L12 5.8l1.2 4.3.1.6.6.1 4.3 1.2-4.3 1.2-.6.2-.1.6-1.2 4.2-1.2-4.3zM12 2L9.9 9.9 2 12l7.9 2.1L12 22l2.1-7.9L22 12l-7.9-2.1L12 2z"
  }), React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#231F20"
  }, React.createElement("path", {
    d: "M5.755 17.615l1.202-1.202.566.566L6.32 18.18zM16.413 17.043l.566-.566 1.202 1.203-.566.565zM16.416 6.927l1.203-1.202.565.566-1.202 1.202zM5.772 6.442l.565-.566L7.54 7.08l-.566.565z"
  })));
};

ReligionSvg.displayName = "ReligionSvg";
export default ReligionSvg;